import { RouteObject } from 'react-router'
import { Overview } from './overview'
import { Root } from './root'

export const DASHBOARD_ROUTES: RouteObject = {
	path: 'dashboard',
	element: <Root />,
	children: [
		{
			path: '',
			element: <Overview />,
		},
	],
}
